import {Urls} from "component/const/Urls";

export const sideBarConst = [[
    {holder: "나의 활동 정보", for: '사용자'},
    {link: Urls.testApp, holder: "시험 접수", for: '사용자'},
    {link: Urls.test, holder: "시험 응시", for: '사용자'},
    {link: Urls.testResult, holder: "시험 결과", for: '사용자'},
    {link: Urls.qualification, holder: "자격증 신청", for: '사용자'},
    {link: Urls.transactions, holder: "결제 내역", for: '사용자'},
    {link: Urls.create, holder: "시험 출제", for: '출제자'},
    {link: Urls.grade, holder: "시험 채점", for: '관리자'},
    {link: Urls.notice, holder: "주의 영역 채점", for: '관리자'},
    {link: Urls.feedback, holder: "시험 피드백", for: '관리자'},
],[
    {holder: "나의 기본 정보"},
    {link: Urls.profile, holder: "프로필 관리", for: '사용자'},
    {link: Urls.alert, holder: "알림 설정", for: '사용자'},
    {link: Urls.ask, holder: "1:1 문의", for: '사용자'},
]
]

export const qualificationList = [
    {
    "번호": "1",
    "선택": "",
    "자격증 종류": "자격증<br/>인쇄: 2000<br/>배송 : 4000원(배송비포함)",
    "방식": "인쇄 배송",
    "미리보기": "미리보기",
    "출력 수": "1",
    "출력 상태": "신청 후 3일동안 인쇄 가능",
    "배송 상태": "",
},{
    "번호": "2",
    "선택": "",
    "자격증 종류": "카드 자격증<br/>배송 : 5000원",
    "방식": "배송",
    "미리보기": "미리보기",
    "출력 수": "2",
    "출력 상태": "",
    "배송 상태": "",
},{
    "번호": "3",
    "선택": "",
    "자격증 종류": "확인서<br/>인쇄: 1000<br/>배송 : 3000원(배송비포함)",
    "방식": "인쇄 배송",
    "미리보기": "미리보기",
    "출력 수": "1",
    "출력 상태": "출력 전",
    "배송 상태": "",
},{
    "번호": "4",
    "선택": "",
    "자격증 종류": "대조필<br/>인쇄: 1000<br/>배송 : 3000원(배송비포함)",
    "방식": "인쇄 배송",
    "미리보기": "미리보기",
    "출력 수": "1",
    "출력 상태": "출력 완료",
    "배송 상태": "배송 완료",
},{
    "번호": "5",
    "선택": "",
    "자격증 종류": "봉사 확인서<br/>인쇄: 1000<br/>배송 : 3000원(배송비포함)",
    "방식": "인쇄 배송",
    "미리보기": "미리보기",
    "출력 수": "1",
    "출력 상태": "출력 완료",
    "배송 상태": "배송 중",
},]

export const transactionList = [
    {
    "번호" : "1",
    "결제일" : "24.01.10.월",
    "결제 내용" : "시험 접수",
    "이용 금액<br/>혜택" : "100,000<br/>(이벤트 할인) -10,000",
    "결제 금액<br/>결제 방법" : "90,000<br/>카드 결제",
    "보유 포인트" : "11,000",
    "결제 상태" : "정상<br/>환불 신청",
},{
    "번호" : "2",
    "결제일" : "24.01.10.월",
    "결제 내용" : "시험 접수",
    "이용 금액<br/>혜택" : "100,000<br/>(이벤트 할인) -10,000",
    "결제 금액<br/>결제 방법" : "90,000<br/>카드 결제",
    "보유 포인트" : "11,000",
    "결제 상태" : "정상<br/>환불 신청",
},{
    "번호" : "3",
    "결제일" : "24.01.10.월",
    "결제 내용" : "시험 접수",
    "이용 금액<br/>혜택" : "100,000<br/>(이벤트 할인) -10,000",
    "결제 금액<br/>결제 방법" : "90,000<br/>카드 결제",
    "보유 포인트" : "11,000",
    "결제 상태" : "정상<br/>환불 신청",
},{
    "번호" : "4",
    "결제일" : "24.01.10.월",
    "결제 내용" : "시험 접수",
    "이용 금액<br/>혜택" : "100,000<br/>(이벤트 할인) -10,000",
    "결제 금액<br/>결제 방법" : "90,000<br/>카드 결제",
    "보유 포인트" : "11,000",
    "결제 상태" : "정상<br/>환불 신청",
},]
